module.exports = __webpack_public_path__ + "static/media/icon-ppcom.a2605cf5.svg";